import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

const LIN = "#EDEDE6";

const SkeletonItem = ({ last }) => (
	<div style={{
		display: "flex",
		alignItems: "center",
		gap: 12,
		padding: "14px 16px",
		borderBottom: last ? "none" : "1px solid " + LIN,
	}}>
		{/* Avatar */}
		<Skeleton variant="circle" width={42} height={42} style={{ flexShrink: 0 }} />

		{/* Content */}
		<div style={{ flex: 1, minWidth: 0 }}>
			<Skeleton variant="text" width="45%" height={16} style={{ marginBottom: 4 }} />
			<Skeleton variant="text" width="60%" height={18} style={{ marginBottom: 4 }} />
			<Skeleton variant="text" width="40%" height={14} style={{ marginBottom: 6 }} />
			<Skeleton variant="text" width="35%" height={14} />
		</div>

		{/* Chevron */}
		<Skeleton variant="text" width={8} height={20} style={{ flexShrink: 0 }} />
	</div>
);

const SkeletonGroup = ({ count }) => (
	<div style={{
		backgroundColor: "#fff",
		borderRadius: 12,
		margin: "0 16px",
		overflow: "hidden",
		boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
		marginBottom: 12,
	}}>
		{Array.from({ length: count }).map((_, i) => (
			<SkeletonItem key={i} last={i === count - 1} />
		))}
	</div>
);

const CardReservationSkeleton = ({ count = 4 }) => (
	<div style={{ backgroundColor: "#F6F6F3", paddingTop: 12, paddingBottom: 60, minHeight: "calc(100vh - 200px)" }}>
		{/* Section label placeholder */}
		<Skeleton variant="text" width={80} height={14} style={{ margin: "0 16px 8px" }} />
		<SkeletonGroup count={Math.min(count, 3)} />

		{count > 3 && (
			<>
				<Skeleton variant="text" width={80} height={14} style={{ margin: "12px 16px 8px" }} />
				<SkeletonGroup count={count - 3} />
			</>
		)}
	</div>
);

export default CardReservationSkeleton;
